import {BaseTaxService} from "./baseTaxService";
import {Duty, DutyType} from "../../objects/calculator/duty";
import {TariffHelper} from "../../common/helpers/tariffHelper";
/**
 * Created by alex.y on 8/31/2017.
 */

export class UsaTaxService extends BaseTaxService {

    public parseTariff(tariff: string): Duty[] {
        let result: Duty[] = [];

        if(TariffHelper.isCustomTariff(tariff)) {
            result.push(new Duty({
                DutyType: DutyType.Manual,
                Value: 0,
                Measure: "",
                Quantity: 0,
                ExtraDuties: []
            }));

            return result;
        }

        if (tariff.toLowerCase().trim() == "free") {
            result.push(new Duty({
                DutyType: DutyType.Percent,
                Value: 0,
                Measure: "",
                Quantity: 0,
                ExtraDuties: []
            }));
        }

        let duties = tariff.split('+');//get different duties

        for (let duty of duties) {
            let parsedDuty = 0;
            let dutyType: DutyType;
            let measure: string = "";
            let extraDuties: Duty[] = [];

            if (duty.includes("%")) {
                let parsed = duty.split("%");

                parsedDuty = Number.parseFloat(parsed[0]);

                if (parsed.length > 1 && parsed[1]) { //has text after %

                    if (parsed[1].includes("<u>")) //there are 20 columns with 2.5%<u></u> tariff, that broke logic
                        parsed[1] = parsed[1].replace(new RegExp("(<u>)(</u>)"), "").trim();

                    if (parsed[1])
                        measure = parsed[1];
                }

                dutyType = DutyType.Percent;
            }
            else if (duty.includes("less")) {
                //If duty contains less so it's something like
                //3.6606¢/kg less 0.020668¢/kg for each degree under 100 degrees (and fractions of a degree in proportion) but not less than 3.143854¢/kg
                let regex = /(.+?)less\W(\d+[.][^\s]+)\s+[^\d]+((\w+) degrees?).*\s+(\d.*)/g;

                let sugarTariffsArray = regex.exec(duty);

                let baseSugarTariff = sugarTariffsArray[1].trim().split("/");
                let eachSugarTariff = sugarTariffsArray[2].trim().split("/");
                let notMoreSugarTariff = sugarTariffsArray[5].trim().split("/");
                let degreeSugarTariff = sugarTariffsArray[4].trim();

                measure = baseSugarTariff[1];//TODO
                parsedDuty = this.getAmount(baseSugarTariff[0]);

                extraDuties.push(new Duty({
                    DutyType: DutyType.LessTariff,
                    Value: Number.parseFloat(eachSugarTariff[0]),
                    Measure: eachSugarTariff[1],
                    Quantity: null,
                    ExtraDuties: []
                }));

                extraDuties.push(new Duty({
                    DutyType: DutyType.Less,
                    Value: Number.parseFloat(notMoreSugarTariff[0]),
                    Measure: notMoreSugarTariff[1],
                    Quantity: null,
                    ExtraDuties: []
                }));

                extraDuties.push(new Duty({
                    DutyType: DutyType.Degree,
                    Value: Number.parseFloat(degreeSugarTariff),
                    Measure: "degree",
                    Quantity: null,
                    ExtraDuties: []
                }));

                dutyType = DutyType.Sugar;

            }
            else {
                let parsed = duty.trim().split(new RegExp("[\\s/](.+)?"));//first space or slash

                let price = parsed[0];
                measure = parsed[1];

                parsedDuty = this.getAmount(price);
                dutyType = DutyType.PerItem;
            }

            result.push(new Duty({
                DutyType: dutyType,
                Value: parsedDuty,
                Measure: measure,
                Quantity: null,
                ExtraDuties: extraDuties
            }));
        }

        return result;
    }

    private getAmount(price: string): number {
        if (price.includes("¢") || price.includes("&cent;")) {
            var resultPrice = Number.parseFloat(price.split(new RegExp("¢|{&cent;}"))[0]);

            return resultPrice / 100;
        }

        if (price.includes("$"))
            return Number.parseFloat(price.split('$')[1]);
    }


}


// WEBPACK FOOTER //
// ./app/services/calculator/usaTaxService.ts